import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState } from '@src/store/store';
import { ROUTE_AUTH_FULL_PATH } from '@src/constants/URLS.const';
import { useAuth0 } from '@auth0/auth0-react';
import LoaderCircle from '@src/components/Loading/circle/circle';

export function ProtectedRoute() {
  const { isLoading } = useAuth0();

  const accessToken = useSelector(
    (state: RootState) => state.user.user?.accessToken
  );

  const location = useLocation();

  if (isLoading) {
    return <LoaderCircle />;
  }

  if (!accessToken) {
    return (
      <Navigate
        to={`${ROUTE_AUTH_FULL_PATH}?redirect-url=${encodeURIComponent(
          location.pathname + location.search
        )}`}
        replace
      />
    );
  }

  return <Outlet />;
}
